<template>
  <div
    class="kard"
    :class="{isTrc10:element.isTrc10}"
    v-if="!isMyElement || (isMyElement && showBlank) || ((isMyElement && !showBlank) && element.myBalance > 0 )"
    @click.self="reloadElement()"
  >
    <b-loading class="loading" :is-full-page="false" :active.sync="isLoading"></b-loading>
    <div class="header">
      <div>{{element.id}}</div>
      <a href="#">{{element.name}}</a>
      <br />
      <a v-if="element.isTrc10" :href="explorerUrl+'/#/token/'+element.tokenIdOrAddress">
        <small>TRC10:</small>
        {{element.tokenIdOrAddress}}
      </a>
      <a v-else :href="explorerUrl+'/#/token20/'+element.tokenIdOrAddress">
        <small>TRC20:</small>
        {{element.tokenIdOrAddress.substr(0,3) + ".." + element.tokenIdOrAddress.substr(32,34)}}
      </a>
    </div>
    <div class="logo" :style="{backgroundImage:'url('+element.imgsrc+')'}"></div>
    <div class="balance">
      <template v-if="isMyElement">
        <div>
          <small>Balance:</small>
          {{element.myBalance / Math.pow(10, element.decimal)}}
        </div>
      </template>
      <template v-else>
        <div>
          <small>Available:</small>
          {{element.availableHavestBalance / Math.pow(10, element.decimal)}}
        </div>
        <div>
          <small>Balance:</small>
          {{element.totalUserBalance / Math.pow(10, element.decimal)}}
        </div>
        <div class="speedup-info" v-if="element.isSpeedUp">
          <p>
            <small>Pay</small>
            {{element.elementConsum / Math.pow(10, element.decimal)}}
          </p>
          <p>
            <small>to reduce</small>
            {{element.minutesBonus}}
            <small>minutes</small>
          </p>
        </div>
      </template>
    </div>
    <div class="columns is-mobile is-multiline" v-if="isMyElement">
      <b-numberinput
        class="column is-12"
        controls-position="compact"
        min="1"
        size="is-small"
        controls-rounded
        v-model="value"
        :step="1/Math.pow(10,element.decimal)"
      ></b-numberinput>
      <div class="column is-6">
        <div class="button is-primary is-small" @click="deposit(value * Math.pow(10,element.decimal))">Deposit</div>
      </div>
      <div class="column is-6">
        <div class="button is-danger is-small" @click="withdraw(value * Math.pow(10,element.decimal))">Withdraw</div>
      </div>
    </div>
  </div>
</template>

<script>
import contract from "./../Utils/Contract.js";

export default {
  data() {
    return {
      value: 100,
      isLoading: false
    };
  },
  computed: {
    explorerUrl: function() {
      return this.$store.state.isMainnet
        ? "https://tronscan.org"
        : "https://shasta.tronscan.org";
    }
  },
  props: {
    element: Object,
    showBlank: {
      type: Boolean,
      default: false
    },
    isMyElement: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  methods: {
    deposit: async function(amount) {
      try {
        this.isLoading = true;
        await contract.depositElement(this.element, amount);
        this.isLoading = false;
        this.$toast.open({
          message: "Deposit success!",
          type: "is-success"
        });
      } catch (e) {
        this.isLoading = false;
        this.$toast.open({
          message: e.toString(),
          type: "is-danger"
        });
      }
    },
    withdraw: async function(amount) {
      try {
        this.isLoading = true;
        await contract.withdrawElement(this.element.id, amount);
        this.isLoading = false;

        this.$toast.open({
          message: "Withdraw success!",
          type: "is-success"
        });
      } catch (e) {
        this.isLoading = false;
        this.$toast.open({
          message: e.toString(),
          type: "is-danger"
        });
      }
    },
    reloadElement: async function() {
      try {
        this.isLoading = true;
        await contract.loadElement(this.element.id);
        if (this.isMyElement)
          await contract.loadBalance(
            this.element.id,
            this.$store.state.myAddress
          );
        this.element = contract.elements[this.element.id];
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style>
.kard:hover {
  transform: scale(1.05);
  box-shadow: rgba(31, 42, 75, 0.3) 0px 20px 40px;
}
.kard {
  position: relative;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
  position: relative;
  box-shadow: rgba(31, 42, 75, 0.2) 0px 20px 40px;
  background: linear-gradient(
    to top,
    #155799,
    #159957
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;
  overflow: hidden;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1) 0s;
}
.isTrc10 {
  background: linear-gradient(to top, #009688, #8bc34a);
}

.kard .logo {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  box-shadow: #8888884a 0 5px 10px;
}
.kard .header {
  padding: 10px;
}
.kard .header a {
  color: white;
  font-size: small;
}
.kard .header div {
  color: white;
  font-weight: bold;
  font-size: 100px;
  position: absolute;
  /* z-index: 20; */
  opacity: 0.1;
  right: 0;
  top: -30px;
}
.kard .balance {
  text-align: left;
  margin: 10px 5px 5px 5px;
  color: white;
}
.kard .speedup-info {
  background: #eee9;
  padding: 2px;
  border-radius: 10px;
  text-align: center;
}
</style>
